<template>    
    <v-dialog
      v-model="dialog"
      width="500"
    >      
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
            Informe Liquidación Comerciales
        </v-card-title>
        <v-layout wrap align-center>
            <v-flex xs8 offset-xs2>
                <v-select
                :items="items"
                label="Seleccione una opción"
                v-model="tipoInforme"                
                ></v-select>
            </v-flex>
        </v-layout>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="closeOK"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
</template>
<script>
export default {
    name: 'dialogInformeComerciales',
    data () {
      return {
        items: ['Contado','Crédito']
      }
    },
    methods:{
        close(){
            this.dialog = false;                        
        },
        closeOK(){
            this.getLiqReport();
            this.dialog = false;                        
        }
    },
    computed:{
        dialog: {
            get(){
                return this.$store.state.dialogInformeComerciales;
            },
            set(value){
                this.$store.state.dialogInformeComerciales = value;
            }
        },
        tipoInforme:{
            get(){
                return this.$store.state.tipoInforme;
            },
            set(value){
                this.$store.state.tipoInforme = value;
            }
        }
    }
}
</script>

